(() => {
  const gifts = new WeakMap();

  function initGiftMessages(root = document) {
    root.querySelectorAll('.product-gift-message').forEach((block) => {
      const input = block.querySelector('[data-paid-gift-message]');
      const open = block.querySelector('[data-gift-open]');
      const dialog = block.querySelector('dialog');
      const label = block.querySelector('[data-gift-button-label]');
      const preview = block.querySelector('[data-gift-preview]');
      if (!input || !open || !dialog || gifts.has(input)) return;
      const state = { message: '' };
      gifts.set(input, state);
      input.disabled = false;
      input.removeAttribute('name');
      const update = () => {
        label.textContent = state.message ? open.dataset.editLabel : open.dataset.addLabel;
        preview.textContent = state.message;
        preview.hidden = !state.message;
      };
      open.addEventListener('click', () => {
        input.value = state.message;
        dialog.showModal();
        input.focus();
      });
      block.querySelector('[data-gift-save]').addEventListener('click', () => {
        if (!input.reportValidity()) return;
        state.message = input.value.trim();
        update();
        dialog.close();
      });
      block.querySelector('[data-gift-cancel]').addEventListener('click', () => dialog.close());
      block.querySelector('[data-gift-remove]').addEventListener('click', () => {
        state.message = '';
        update();
        dialog.close();
      });
      dialog.addEventListener('close', () => {
        input.value = state.message;
        open.focus();
      });
      open.disabled = false;
    });
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.error = false;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        spinner?.classList.remove('hidden');
        let added = false;

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const giftInput = Array.from(document.querySelectorAll('[data-paid-gift-message]'))
            .find((input) => input.form === this.form);
          const message = giftInput && gifts.get(giftInput)?.message;
          formData.delete('properties[Gift message]');

          if (message) {
            for (const [key, value] of Array.from(formData.entries())) {
              let itemKey;
              if (['id', 'quantity', 'selling_plan'].includes(key)) itemKey = `items[0][${key}]`;
              else if (key.startsWith('properties[')) itemKey = `items[0][properties]${key.slice(10)}`;
              else continue;
              formData.delete(key);
              formData.append(itemKey, value);
            }
            if (!formData.has('items[0][quantity]')) formData.set('items[0][quantity]', '1');
            formData.set('items[0][properties][Gift message]', message);
            formData.set('items[1][id]', giftInput.dataset.giftVariant);
            formData.set('items[1][quantity]', '1');
            formData.set('items[1][properties][Gift message]', message);
          }

          if (this.cart) {
            formData.set('sections', this.cart.getSectionsToRender().map((section) => section.id).join(','));
            formData.set('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          const result = await fetch(routes.cart_add_url, config);
          const response = await result.json();
          if (!result.ok || response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form', productVariantId: variantId,
              errors: response.errors || response.description, message: response.message,
            });
            this.handleErrorMessage(response.description || response.message || 'Unable to add to cart. Please try again.');
            return;
          }
          added = true;
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form', productVariantId: variantId, cartData: response,
          });
          const renderResponse = response.items?.length
            ? { ...response, ...response.items[0], sections: response.sections }
            : response;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => this.cart.renderContents(renderResponse));
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(renderResponse);
          }
        } catch (error) {
          console.error(error);
          this.handleErrorMessage(added
            ? 'Added to your cart. Refresh the page to view your cart.'
            : 'Unable to confirm the cart update. Check your cart before trying again.');
        } finally {
          this.submitButton.classList.remove('loading');
          if (added) this.cart?.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGiftMessages(), { once: true });
  } else {
    initGiftMessages();
  }
  document.addEventListener('shopify:section:load', (event) => initGiftMessages(event.target));
})();
